exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pz_modal.auth > .modal_content {\n  width: 856px;\n}\n.pz_modal.auth > .modal_content > .modal-body {\n  padding: 0 24px;\n}\n", ""]);

